module.exports = __webpack_public_path__ + "static/media/study-kids.59e229d4.png";